<template>
  <v-dialog
    v-model="dialogVisible"
    max-width="600px"
    persistent
  >
    <v-card class="add-insured-dialog">
      <!-- 标题栏 -->
      <v-card-title class="dialog-header">
        <span class="dialog-title">添加被保险人</span>
        <v-btn
          icon
          small
          class="close-btn"
          @click="closeDialog"
        >
          <v-icon size="20">close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- 表单内容 -->
      <v-card-text class="dialog-content">
        <v-form ref="insuredForm" v-model="valid">
          <div class="form-row">
            <div class="form-field">
              <label class="field-label">姓名 <span class="required">*</span></label>
              <v-text-field
                v-model="form.name"
                placeholder="被保人姓名"
                outlined
                dense
                solo
                :rules="[v => !!v || '请输入姓名']"
                class="custom-field"
              ></v-text-field>
            </div>

            <div class="form-field">
              <label class="field-label">证件类型 <span class="required">*</span></label>
              <v-select
                v-model="form.certType"
                :items="certTypeOptions"
                placeholder="请输入"
                outlined
                dense
                solo
                :rules="[v => (v !== '' && v !== null && v !== undefined) || '请选择证件类型']"
                class="custom-field"
              ></v-select>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field">
              <label class="field-label">联系方式 <span class="required">*</span></label>
              <v-text-field
                v-model="form.phone"
                placeholder="请输入手机号码"
                outlined
                dense
                solo
                :error-messages="phoneError"
                class="custom-field"
                @blur="validatePhone"
                @input="phoneError = ''"
              ></v-text-field>
            </div>

            <div class="form-field">
              <label class="field-label">证件号码 <span class="required">*</span></label>
              <v-text-field
                v-model="form.certNo"
                placeholder="请输入"
                outlined
                dense
                solo
                :error-messages="certNoError"
                class="custom-field"
                @blur="validateCertNo"
                @input="certNoError = ''"
              ></v-text-field>
            </div>
          </div>

          <!-- 非身份证时显示出生日期和性别 -->
          <div class="form-row" v-if="form.certType && form.certType !== 1">
            <div class="form-field">
              <label class="field-label">出生日期<span class="required">*</span></label>
              <v-menu
                v-model="birthDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="form.birthday"
                    placeholder="请选择"
                    readonly
                    outlined
                    dense
                    solo
                    :rules="birthDateRules"
                    class="custom-field"
                    v-on="on"
                    append-icon="event"
                    clearable
                    @click:clear="form.birthday = ''"
                  ></v-text-field>
                </template>
              <v-date-picker
                v-model="form.birthday"
                @input="birthDateMenu = false"
                :max="maxBirthDate"
                :min="minBirthDate"
                no-title
                locale="zh-cn"
              ></v-date-picker>
              </v-menu>
            </div>

            <div class="form-field">
              <label class="field-label">性别<span class="required">*</span></label>
              <v-select
                v-model="form.gender"
                :items="genderOptions"
                placeholder="请选择"
                outlined
                dense
                solo
                :rules="[v => (v !== '' && v !== null && v !== undefined) || '请选择性别']"
                class="custom-field"
                append-icon="keyboard_arrow_down"
              ></v-select>
            </div>
          </div>

          <div class="form-row single-field">
            <div class="form-field">
              <label class="field-label">同投保人关系<span class="required">*</span></label>
              <v-select
                v-model="form.relationType"
                :items="relationTypeOptions"
                placeholder="请选择"
                outlined
                dense
                solo
                :rules="[v => (v !== '' && v !== null && v !== undefined) || '请选择同投保人关系']"
                class="custom-field"
                append-icon="keyboard_arrow_down"
              ></v-select>
            </div>
          </div>
        </v-form>
      </v-card-text>

      <!-- 底部按钮 -->
      <v-card-actions class="dialog-footer">
        <v-btn
          outlined
          color="#999"
          class="footer-btn"
          @click="closeDialog"
        >
          取消
        </v-btn>
        <v-btn
          color="#dd122a"
          class="footer-btn confirm-btn"
          @click="confirmAdd"
        >
          确定
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AddInsuredPerson',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valid: true,
      form: {
        name: '',
        certType: '',
        phone: '',
        certNo: '',
        birthday: '',
        gender: '',
        relationType: 9,
      },
      certNoError: '',
      phoneError: '',
      birthDateMenu: false,
      certTypeOptions: [
        { text: '身份证', value: 1 },
        { text: '护照', value: 2 },
        { text: '军人证', value: 3 },
        { text: '港澳通行证', value: 4 },
        { text: '驾驶证', value: 5 },
        { text: '港澳居民来往内地通行证', value: 6 },
        { text: '临时身份证', value: 7 },
        { text: '外国人永久居留身份证', value: 8 },
        { text: '港澳台居民居住证', value: 9 }
      ],
      relationTypeOptions: [
        { text: '本人', value: 1 },
        { text: '配偶', value: 2 },
        { text: '父子', value: 3 },
        { text: '父女', value: 4 },
        { text: '受益人', value: 5 },
        { text: '被保人', value: 6 },
        { text: '投保人', value: 7 },
        { text: '转换不详', value: 8 },
        { text: '其他', value: 9 },
        { text: '母子', value: 10 },
        { text: '母女', value: 11 },
        { text: '兄弟', value: 12 },
        { text: '姊妹', value: 13 },
        { text: '兄妹', value: 14 },
        { text: '姐弟', value: 15 },
        { text: '祖孙', value: 16 },
        { text: '雇佣', value: 17 },
        { text: '子女', value: 18 },
        { text: '父母', value: 19 }
      ],
      genderOptions: [
        { text: '男', value: 0 },
        { text: '女', value: 1 }
      ]
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    // 最小出生日期（90周岁）
    minBirthDate() {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 90);
      return date.toISOString().split('T')[0];
    },
    // 最大出生日期（30天）
    maxBirthDate() {
      const date = new Date();
      date.setDate(date.getDate() - 30);
      return date.toISOString().split('T')[0];
    },
    // 出生日期校验规则
    birthDateRules() {
      return [
        v => !!v || '请选择出生日期',
        v => {
          if (!v || this.form.certType !== 1) return true;
          const birthDate = new Date(v);
          const today = new Date();
          
          // 计算年龄（天数）
          const diffTime = today - birthDate;
          const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
          
          // 校验：必须大于30天且小于90周岁
          const minDays = 30;
          const maxDays = 90 * 365 + 22; // 90年，考虑闰年
          
          if (diffDays < minDays) {
            return '被保险人年龄须满30天';
          }
          if (diffDays > maxDays) {
            return '被保险人年龄须小于90周岁';
          }
          return true;
        }
      ];
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.resetForm();
      }
    }
  },
methods: {
    // 验证手机号格式
    validatePhone() {
      const phone = this.form.phone;
      if (!phone) {
        this.phoneError = '请输入联系方式';
        return false;
      }
      // 手机号：1开头的11位数字
      if (/^1[3-9]\d{9}$/.test(phone)) {
        this.phoneError = '';
        return true;
      }
      this.phoneError = '请输入正确的手机号码';
      return false;
    },
    
    // 验证身份证号码格式
    validateCertNo() {
      const certNo = this.form.certNo;
      if (!certNo) {
        this.certNoError = '请输入证件号码';
        return false;
      }
      
      // 只有身份证才进行格式验证
      if (this.form.certType === 1) {
        // 18位身份证验证
        const idCardReg = /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
        if (!idCardReg.test(certNo)) {
          this.certNoError = '请输入正确的身份证号码';
          return false;
        }
        
        // 校验码验证
        const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        const checkCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
        
        let sum = 0;
        for (let i = 0; i < 17; i++) {
          sum += parseInt(certNo[i]) * factor[i];
        }
        
        const checkDigit = checkCode[sum % 11];
        const lastChar = certNo[17].toUpperCase();
        
        if (lastChar !== checkDigit) {
          this.certNoError = '身份证校验码不正确';
          return false;
        }
      }
      
      this.certNoError = '';
      return true;
    },
    
    resetForm() {
      this.form = {
        name: '',
        certType: '',
        phone: '',
        certNo: '',
        birthday: '',
        gender: '',
        relationType: 9
      };
      this.certNoError = '';
      this.phoneError = '';
      this.birthDateMenu = false;
      this.valid = true;
      // 重置表单验证状态
      this.$refs.insuredForm && this.$refs.insuredForm.resetValidation();
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    confirmAdd() {
      // 触发表单验证
      const isValid = this.$refs.insuredForm.validate();
      if (!isValid) {
        return;
      }
      // 验证手机号格式
      if (!this.validatePhone()) {
        return;
      }
      // 验证身份证号码格式
      if (!this.validateCertNo()) {
        return;
      }
      console.log(this.form)
      this.$emit('confirm', { ...this.form });
      this.closeDialog();
    }
  }
};
</script>

<style lang="scss" scoped>
.add-insured-dialog {
  border-radius: 8px;

  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #e8e8e8;

    .dialog-title {
      font-size: 16px;
      font-weight: 500;
      color: #333;
    }

    .close-btn {
      margin: 0;
      color: #999;
    }
  }

  .dialog-content {
    padding: 24px 20px;

    .required {
      color: #ff4d4f;
      margin-left: 2px;
    }

    .form-row {
      display: flex;
      gap: 16px;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      &.single-field {
        .form-field {
          width: calc(50% - 8px);
          
          &:last-child {
            width: auto;
            max-width: 270px;
          }
        }
      }
    }

    .form-field {
      flex: 1;

      .field-label {
        display: block;
        font-size: 14px;
        color: #666;
        margin-bottom: 8px;
      }

      .custom-field {
        .v-input__control {
          min-height: 40px;
        }

        .v-input__slot {
          min-height: 40px;
          background-color: #fff !important;
          border: 1px solid #e0e0e0 !important;
          border-radius: 4px;

          &::before,
          &::after {
            display: none;
          }
        }

        .v-text-field__slot input::placeholder {
          color: #bbb;
        }
      }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 12px 20px 20px;
    border-top: none;

    .footer-btn {
      text-transform: none;
      font-size: 14px;
      height: 36px;
      min-width: 80px;
      border-radius: 4px;

      &.confirm-btn {
        color: #fff;
      }
    }
  }
}
</style>
